import classnames from 'classnames';
import { IconProps } from '../types';

/**
 * The iDEAL acceptance mark, from Shopify's MIT-licensed payment_icons pack
 * (activemerchant/payment_icons). Kept as the scheme ships it, frame included.
 */
export default function IdealIcon(props: IconProps) {
  const { className, style } = props;

  return (
    <svg className={classnames('h-5', className)} viewBox="0 0 38 24" style={style} role="img" aria-label="iDEAL">
      <g clipPath="url(#pi-clip0_19918_2)">
        <path
          fill="#000"
          opacity=".07"
          d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z"
        />
        <path
          fill="#fff"
          d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z"
        />
        <g clipPath="url(#pi-clip1_19918_2)">
          <path
            d="M11.5286 5.35759V18.694H19.6782C25.0542 18.694 27.3855 15.8216 27.3855 12.0125C27.3855 8.21854 25.0542 5.35742 19.6782 5.35742L11.5286 5.35759Z"
            fill="white"
          />
          <path
            d="M19.7305 5.06445C26.8437 5.06445 27.9055 9.4164 27.9055 12.0098C27.9055 16.5096 25.0025 18.9876 19.7305 18.9876H11.0118V5.06462L19.7305 5.06445ZM11.6983 5.71921V18.3329H19.7305C24.5809 18.3329 27.2195 16.1772 27.2195 12.0098C27.2195 7.72736 24.3592 5.71921 19.7305 5.71921H11.6983Z"
            fill="black"
          />
          <path
            d="M12.7759 17.3045H15.3474V12.9372H12.7757M15.6593 10.7375C15.6593 11.5796 14.944 12.2625 14.0613 12.2625C13.179 12.2625 12.4633 11.5796 12.4633 10.7375C12.4633 10.3332 12.6316 9.94537 12.9313 9.65945C13.231 9.37352 13.6374 9.21289 14.0613 9.21289C14.4851 9.21289 14.8915 9.37352 15.1912 9.65945C15.4909 9.94537 15.6593 10.3332 15.6593 10.7375Z"
            fill="black"
          />
          <path
            d="M20.7043 11.4505V12.1573H18.8719V9.32029H20.6452V10.0266H19.6127V10.3556H20.5892V11.0616H19.6127V11.4503L20.7043 11.4505ZM21.06 12.158L21.9569 9.31944H23.0109L23.9075 12.158H23.1362L22.9683 11.6089H21.9995L21.8308 12.158H21.06ZM22.216 10.9028H22.7518L22.5067 10.1007H22.4623L22.216 10.9028ZM24.2797 9.31944H25.0205V11.4505H26.1178C25.8168 7.58344 22.6283 6.74805 19.7312 6.74805H16.6418V9.32063H17.0989C17.9328 9.32063 18.4505 9.86014 18.4505 10.7275C18.4505 11.6228 17.9449 12.157 17.0989 12.157H16.6422V17.3052H19.7308C24.4416 17.3052 26.081 15.218 26.1389 12.1572H24.2797V9.31944ZM16.6415 10.0273V11.4505H17.0992C17.4165 11.4505 17.7094 11.3631 17.7094 10.7278C17.7094 10.1067 17.3834 10.0271 17.0992 10.0271L16.6415 10.0273Z"
            fill="#CC0066"
          />
        </g>
      </g>
      <defs>
        <clipPath id="pi-clip0_19918_2">
          <rect width="38" height="24" fill="white" />
        </clipPath>
        <clipPath id="pi-clip1_19918_2">
          <rect width="17" height="14" fill="white" transform="translate(11 5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
